import _ from 'lodash';
import axios from 'axios';

import { actions as usuarioActions, selectors as usuarioSelectors } from '../../redux/modules/usuario';

export default axios;

export const registerAxiosInterceptors = (store) => {
  axios.interceptors.request.use(config => {

    config.headers = config.headers || {};
    const token = usuarioSelectors.getAccessToken(store.getState());

    if (Boolean(token)) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
    error => Promise.reject(error)
  );

  axios.interceptors.response.use(
    // success
    response => response,

    // error
    (error) => {

      const isForceLogout = Boolean(_.get(error, 'config.force_logout'));
      if (isForceLogout) {
        // erro ao deslogar, nada a fazer
        return Promise.reject(error);
      }

      const errorHasResponse = Boolean(error && error.response);

      if (errorHasResponse && error.response.status === 401) {
        // token já não está mais autorizado
        store.dispatch(usuarioActions.forceLogoutUser());
      }

      return Promise.reject(error);
    });
};
